import { Outlet } from "react-router-dom";
import { useState, createContext, useEffect } from "react";
import Header from "../components/header";
import "./layout.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SideBar3 from "../components/sidebar3";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import DeleteModal from '../components/deleteModal'
import { ModalDialog } from "react-bootstrap";
import Draggable from "react-draggable";
import { getServiceWatchList } from "../services/serviceWatchService";

const ThemeContext = createContext({});
const SwalContext = createContext({});
const RightToLeftDataComContext = createContext({});
const LeftToRightDataComContext = createContext({});
const DeleteModalContext = createContext({});
const ServiceWatchListContext = createContext({});

const deleteConfirmationModal = (props: any) => {
  return (
    <Draggable handle=".modal-header">
      <ModalDialog {...props} />
    </Draggable>
  );
};

export default function BaseLayout() {

  let token = sessionStorage.getItem("token");

  const [deleteModalData, setDeleteModalData] = useState({ openDeleteModal: false, customMessage: '', callBackFunction: null, deleteModalItem: null, type: null, isNotValid: null });

  const closeDeleteModal = () => {
    setDeleteModalData({ openDeleteModal: false, customMessage: '', callBackFunction: null, deleteModalItem: null, type: null, isNotValid: null })
  }

  const [serviceWatchList, setServiceWatchList] = useState([])

  let isLeftDragging = false;
  let isBottomDragging = false;
  let isRightDragging = false;
  const [rightToLeftDataComContextObj, setRightToLeftDataComContextObj] = useState({
    act: '',
    data: null
  });
  const [leftToRightDataComContextObj, setLeftToRightDataComContextObj] = useState({
    act: '',
    data: []
  });

  useEffect(() => {
    if (leftToRightDataComContextObj.act !== '') {
      setTimeout(() => {
        setLeftToRightDataComContextObj({
          act: '',
          data: []
        });
      }, 100);
    }
  }, [leftToRightDataComContextObj]);

  function ResetColumnSizes() {
    // when page resizes return to default col sizes
    let page = document.getElementById("pageFrame");
    if (page) {
      page.style.gridTemplateColumns = "2fr 2px 6fr 2px 2fr";
    }
  }

  function SetCursor(cursor: any) {
    let page = document.getElementById("page");
    if (page) {
      page.style.cursor = cursor;
    }
  }

  function StartLeftDrag() {
    isLeftDragging = true;
    SetCursor("ew-resize");
  }

  function StartBottomDrag(props: {}) {
    isBottomDragging = true;
    SetCursor("ns-resize");
    return;
  }

  function EndDrag() {
    isLeftDragging = false;
    isRightDragging = false;
    isBottomDragging = false;
    SetCursor("auto");
  }

  function OnDrag(event: any) {
    if (isLeftDragging || isRightDragging) {
      let page = document.getElementById("page");
      let leftcol = document.getElementById("leftcol");
      let rightcol = document.getElementById("rightcol");
      if (!page) {
        return false;
      }
      let leftColWidth = isLeftDragging
        ? event.clientX
        : leftcol
          ? leftcol.clientWidth
          : 0;
      let rightColWidth = isRightDragging
        ? page.clientWidth - event.clientX
        : rightcol
          ? rightcol.clientWidth
          : 0;

      let dragbarWidth = 4;
      if (isLeftDragging && leftColWidth <= 190) {
        return false
      } else if (isLeftDragging && ((page.clientWidth - 4 * dragbarWidth - leftColWidth - rightColWidth) <= 200)) {
        return false
      } else {
        let cols = [
          leftColWidth,
          dragbarWidth,
          page.clientWidth - 4 * dragbarWidth - leftColWidth - rightColWidth,
          dragbarWidth
        ];

        let newColDefn = cols.map((c) => c.toString() + "px").join(" ");

        page.style.gridTemplateColumns = newColDefn;

        event.preventDefault();
      }
    } else if (isBottomDragging) {
      let page = document.getElementById("page");
      let header = document.getElementById("header");
      if (!page || !header) {
        return false;
      }
      let footerRowHeight = event.clientY - 69;
      let dragbarHeight = 4;
      if (footerRowHeight <= 190) {
        return false
      }

      let rows = [
        39,
        footerRowHeight,
        dragbarHeight,
        page.clientHeight -
        dragbarHeight -
        39 -
        footerRowHeight,
      ];
      let newRowDefn = rows.map((c) => c.toString() + "px").join(" ");
      page.style.gridTemplateRows = newRowDefn;
      event.preventDefault();
    }
  }

  function fnRightToLeftDataComContext(actionObj: any) {
    setRightToLeftDataComContextObj(actionObj);
  }

  function fnLeftToRightDataComContext(actionObj: any) {
    setLeftToRightDataComContextObj(actionObj);
  }

  const getServiceList = () => {
    getServiceWatchList().then((res: any) => {
      if (res.isSuccess) {
        setServiceWatchList(res.data);
      }
    })
  }

  useEffect(() => {
    if (!!token) {
      getServiceList();
    }
  }, [token])

  return (
    <>
      <div onResize={ResetColumnSizes} className="desktopscreen">
        <ThemeContext.Provider value={toast} >
          <SwalContext.Provider value={Swal}>
            <RightToLeftDataComContext.Provider value={fnRightToLeftDataComContext}>
              <LeftToRightDataComContext.Provider value={leftToRightDataComContextObj}>
                <DeleteModalContext.Provider value={setDeleteModalData}>
                  <ServiceWatchListContext.Provider value={serviceWatchList}>
                    <div
                      id="page"
                      onMouseUp={EndDrag}
                      onMouseMove={(e) => {
                        OnDrag(e);
                      }}
                    >
                      <div id="header">
                        <Header />
                      </div>
                      <div id="leftcol">
                        <SideBar3 rightToLeftDataComContextObj={{ ...rightToLeftDataComContextObj }} fnRightToLeftDataComContext={fnRightToLeftDataComContext} fnLeftToRightDataComContext={fnLeftToRightDataComContext} />
                      </div>
                      {/* <div id="leftdragbar" onMouseDown={StartLeftDrag}></div> */}
                      <Outlet />
                      {/* <div id="bottomdragbar" onMouseDown={StartBottomDrag}></div> */}

                      {/* <div id="footer">

                    
                  </div> */}
                      {/* DELETE MODEL START */}
                      <div className="login-popup">
                        <Modal className="login"
                          show={deleteModalData.openDeleteModal}
                          onHide={() => closeDeleteModal()}
                          backdrop="static"
                          dialogAs={deleteConfirmationModal}
                          animation={false}
                          size="sm"
                          centered
                        >
                          <Modal.Header closeButton style={{ border: "none" }}>
                            <Modal.Title>{deleteModalData.type === 'sync' ? "Confirm" : "Delete"}</Modal.Title>
                          </Modal.Header>
                          <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                            <DeleteModal closeDeleteModal={closeDeleteModal} customMessage={deleteModalData.customMessage} callBackFunction={deleteModalData.callBackFunction} type={!!deleteModalData.type ? deleteModalData.type : null} deleteModalItem={deleteModalData.deleteModalItem} isNotValid={deleteModalData.isNotValid} />
                          </Modal.Body>
                        </Modal>
                      </div>
                      {/* DELETE MODEL END */}

                    </div>
                    <ToastContainer
                      position="top-right"
                      // autoClose={3000}
                      closeOnClick
                    />
                  </ServiceWatchListContext.Provider>
                </DeleteModalContext.Provider>
              </LeftToRightDataComContext.Provider>
            </RightToLeftDataComContext.Provider>
          </SwalContext.Provider>
        </ThemeContext.Provider>
      </div>
      <div className="mobilescreen">Current screen size is not supported. Minimum screen resolution require is 768 * 1024. </div>
    </>
  );
}
export { ThemeContext, SwalContext, RightToLeftDataComContext, LeftToRightDataComContext, DeleteModalContext, ServiceWatchListContext };
